<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { client as apiClient } from './src/client/client.gen'
const { authToken } = useAuth()

// Always provide a dynamic auth getter so requests use the latest token
apiClient.setConfig({
  auth: () => authToken.value ?? localStorage.getItem('auth_token') ?? undefined
})
</script>